import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
// import { newsletterApi } from '../../services/api';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ type: 'error', text: 'Email is required' });
      return;
    }

    setIsSubmitting(true);
    setMessage(null);

    try {
      // Mock submission for now - uncomment when API is ready
      // await newsletterApi.subscribe({ email });
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setMessage({ type: 'success', text: 'Thank you for subscribing!' });
      setEmail('');
      
      // Clear message after 5 seconds
      setTimeout(() => setMessage(null), 5000);
    } catch {
      setMessage({ type: 'error', text: 'Failed to subscribe. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer 
      className="text-gray-700" 
      style={{ 
        backgroundColor: '#f3f4f6',
        paddingTop: '2rem',
        paddingBottom: '1.5rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem'
      }}
    >
      <div 
        className="container mx-auto px-6 md:px-8 lg:px-12" 
        style={{ 
          maxWidth: '1400px',
          margin: '0 auto'
        }}
      >
        {/* Main Footer Content */}
        <div 
          className="pb-8 md:pb-12 lg:pb-16"
          style={{ 
            paddingBottom: '2rem'
          }}
        >
          <div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 lg:gap-16"
            style={{
              display: 'grid',
              gap: '2rem',
              justifyContent: 'center',
              alignItems: 'start'
            }}
          >
            {/* Column 1: Logo and Description */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Link to="/" className="block mb-4 md:mb-6">
                <img 
                  src="/assets/logo/logo.png" 
                  alt="Tanzania Digital Awards"
                  className="w-32 md:w-40 lg:w-44 xl:w-48 h-auto"
                  style={{ height: 'auto' }}
                />
              </Link>
              <p 
                className="text-gray-600 mb-6 md:mb-8 leading-relaxed text-sm" 
                style={{ 
                  lineHeight: '1.8', 
                  color: '#6b7280',
                  marginBottom: '1.5rem',
                  fontSize: '0.875rem'
                }}
              >
                Established on 16th January 2020, the Tanzania Digital Awards honours 
                creativity, innovation and efficacy in harnessing digital space for
                positive societal changes in Tanzania.
              </p>
              
              {/* Social Media Icons */}
              <div 
                className="flex space-x-2 md:space-x-3"
                style={{
                  display: 'flex',
                  gap: '0.5rem'
                }}
              >
                <a 
                  href="https://www.facebook.com/digitalawardstz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-8 h-8 md:w-10 md:h-10 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#000', 
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  aria-label="Facebook"
                >
                  <i className="fa-brands fa-facebook-f text-xs md:text-sm"></i>
                </a>
                <a 
                  href="https://x.com/digitalawardstz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-8 h-8 md:w-10 md:h-10 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#000', 
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  aria-label="Twitter/X"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-3 h-3 md:w-3.5 md:h-3.5">
                    <path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/digitalawardstz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-8 h-8 md:w-10 md:h-10 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#000', 
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  aria-label="Instagram"
                >
                  <i className="fa-brands fa-instagram text-xs md:text-sm"></i>
                </a>
                <a 
                  href="https://www.youtube.com/digitalawardstz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-8 h-8 md:w-10 md:h-10 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300"
                  style={{ 
                    backgroundColor: '#000', 
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.3s ease'
                  }}
                  aria-label="YouTube"
                >
                  <i className="fa-brands fa-youtube text-xs md:text-sm"></i>
                </a>
              </div>
            </div>

            {/* Column 2: Useful Links */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h5 
                className="text-lg font-bold mb-6 text-gray-900" 
                style={{ 
                  fontWeight: '700', 
                  color: '#111827',
                  fontSize: '1.125rem',
                  marginBottom: '1.5rem'
                }}
              >
                Useful Links
              </h5>
              <ul 
                className="space-y-3"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem'
                }}
              >
                <li>
                  <a 
                    href="https://serengetibytes.com" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Serengeti Bytes
                  </a>
                </li>
                <li>
                  <a 
                    href="https://changemakers.co.tz/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Changemakers
                  </a>
                </li>
                <li>
                  <Link 
                    to="/privacy" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/disclaimer" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Disclaimer
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/intellectual" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Intellectual Property Rights
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Contact Info */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h5 
                className="text-lg font-bold mb-6 text-gray-900" 
                style={{ 
                  fontWeight: '700', 
                  color: '#111827',
                  fontSize: '1.125rem',
                  marginBottom: '1.5rem'
                }}
              >
                Contact Info
              </h5>
              <div 
                className="space-y-4"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1rem'
                }}
              >
                <div>
                  <p 
                    className="text-gray-600 leading-relaxed text-sm" 
                    style={{ 
                      lineHeight: '1.8', 
                      color: '#6b7280',
                      fontSize: '0.875rem'
                    }}
                  >
                    8th Floor, Victoria House, Mikocheni<br />
                    Dar es Salaam, Tanzania.
                  </p>
                </div>
                <div>
                  <a 
                    href="mailto:info@digitalawards.co.tz" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm block"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    info@digitalawards.co.tz
                  </a>
                </div>
                <div 
                  className="space-y-1"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.25rem'
                  }}
                >
                  <a 
                    href="tel:+255737957082" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm block"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    +255 737 957082
                  </a>
                  <a 
                    href="tel:+255719579733" 
                    className="text-gray-600 hover:text-gray-900 transition-colors text-sm block"
                    style={{ 
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    +255 719 579733
                  </a>
                </div>
              </div>
            </div>

            {/* Column 4: Newsletter Section */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <h5 
                className="text-lg font-bold mb-6 text-gray-900" 
                style={{ 
                  fontWeight: '700', 
                  color: '#111827',
                  fontSize: '1.125rem',
                  marginBottom: '1.5rem'
                }}
              >
                Subscribe Us
              </h5>
              <div>
                <p 
                  className="text-gray-600 mb-4 md:mb-5 leading-relaxed text-sm" 
                  style={{ 
                    lineHeight: '1.8', 
                    color: '#6b7280',
                    marginBottom: '1rem',
                    fontSize: '0.875rem'
                  }}
                >
                  Subscribe our newsletter for future updates.
                </p>

                {message && (
                  <div 
                    className={`px-4 py-3 rounded-lg mb-4 text-sm ${
                      message.type === 'success' 
                        ? 'bg-green-50 text-green-800 border border-green-200' 
                        : 'bg-red-50 text-red-800 border border-red-200'
                    }`}
                    style={{
                      padding: '0.75rem 1rem',
                      borderRadius: '0.5rem',
                      marginBottom: '1rem',
                      fontSize: '0.875rem'
                    }}
                  >
                    {message.text}
                  </div>
                )}

                <form 
                  onSubmit={handleSubmit} 
                  className="space-y-2 md:space-y-3"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    width: '100%',
                    position: 'relative'
                  }}
                >
                  <div className="relative">
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email..."
                      required
                      disabled={isSubmitting}
                      className="w-full px-3 py-2.5 md:px-4 md:py-3 pl-10 md:pl-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-400 focus:border-transparent text-gray-900 text-sm bg-white"
                      style={{ 
                        borderRadius: '9999px',
                        backgroundColor: '#fff',
                        borderColor: '#d1d5db',
                        padding: '0.625rem 0.75rem 0.625rem 2.5rem',
                        fontSize: '0.875rem'
                      }}
                    />
                    <i className="fa-regular fa-envelope absolute left-3 md:left-4 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  </div>
                  <button 
                    type="submit" 
                    disabled={isSubmitting}
                    className="newsletter-submit-btn w-full px-4 py-2.5 md:px-6 md:py-3 bg-black text-white rounded-full font-semibold hover:bg-gray-800 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm uppercase tracking-wide"
                    style={{
                      backgroundColor: '#000',
                      color: '#fff',
                      borderRadius: '9999px',
                      fontWeight: '600',
                      letterSpacing: '0.05em',
                      padding: '0.625rem 1rem',
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      display: 'block !important',
                      opacity: '1 !important',
                      marginTop: '0.5rem',
                      width: '100%',
                      height: 'auto',
                      minHeight: '40px',
                      border: 'none',
                      cursor: 'pointer',
                      position: 'relative',
                      zIndex: '1'
                    }}
                  >
                    {isSubmitting ? 'Subscribing...' : 'SUBSCRIBE'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Back to Top Button */}
        <div 
          className="flex justify-end mb-6 md:mb-8"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '1.5rem'
          }}
        >
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-10 h-10 md:w-12 md:h-12 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-all duration-300"
            style={{ 
              backgroundColor: '#000', 
              color: '#fff',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              border: 'none',
              cursor: 'pointer'
            }}
            aria-label="Back to top"
          >
            <i className="fa-solid fa-arrow-up text-sm"></i>
          </button>
        </div>

        {/* Copyright Area */}
        <div 
          className="border-t border-gray-300 pt-4 md:pt-6"
          style={{
            borderTop: '1px solid #d1d5db',
            paddingTop: '1rem'
          }}
        >
          <div 
            className="text-center"
            style={{ textAlign: 'center' }}
          >
            <p 
              className="text-gray-600 text-xs md:text-sm" 
              style={{ 
                color: '#6b7280',
                fontSize: '0.75rem'
              }}
            >
              2023 © Designed and Maintained by{' '}
              <a 
                href="https://www.serengetibytes.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-900 hover:text-gray-700 transition-colors font-medium"
                style={{ 
                  color: '#111827', 
                  fontWeight: '500',
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
                }}
              >
                SERENGETI BYTES
              </a>
              . All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
